import { Button, Heading, Input, Text, Box, Card, CardBody, useToast} from "@chakra-ui/react";
import React, { useState , useRef} from "react";
import axios from 'axios'
import { v4 as uuid } from "uuid";
import { Auth } from "../../component/Auth";

// import { Form } from "react-router-dom";

function PanVerification({kycCategory,partyId, onClose4}) {
  // const [files, setFiles] = useState([]); // face match img
  const [files2, setFiles2] = useState([]); // ocr img
  const [ocrSpinner, setOcrSpinner] = useState(false); // face spinner
  const toast = useToast()
  const [ocrResult, setOcrResult] = useState(false); // face result
  // const [faceSpinner, setFaceSpinner] = useState(false); // ocr result
  // const [faceResult, setFaceResult] = useState(false); // ocr result
  // const [faceRes, setFaceRes] = useState({}); // facematch res data
  // const [ocrRes, setOcrRes] = useState({}); // ocr res data
  const [ocrBtn, setOcrBtn] = useState(false); // ocr btn disabled
  // const [faceBtn, setFaceBtn] = useState(false); // face btn disabled

  // console.log(ocrRes)

  // face ref
  // const errorFace = useRef(null);

  // ocr ref
  // const imgErr = useRef(null)
  // const imgErrFace = useRef(null)


  // const faceImg = (e) => {
  //   setFiles(Array.from(e.target.files));
  // };

  const ocrImg = (e) => {
    setFiles2(Array.from(e.target.files));
  };

    // Ocr Verify ----------------------------------------------------------------------
    const verifyOcr = () => {
        // const myHeaders = new Headers();
        // myHeaders.append("client_id", "ralcosynergy_staging");
        // myHeaders.append("client_secret", "493YXjr4HscHfXM1GfwAw276hChG6lzo");
        // myHeaders.append("module_secret", "NK40kCOtccWjjzlgNXWSwC6RrYOjmU4w");
        // myHeaders.append("Content-Type", "multipart/form-data");
        setOcrSpinner(true)
        setOcrBtn(true)
        const formdata = new FormData();
        formdata.append("files", files2[0]);
        formdata.append("partyId", `${partyId}`);
        formdata.append("contentTypeEnumId", "PAN");
        
        var requestOptions = {
          method: 'POST',
          body: formdata,
          redirect: 'follow',
          headers: {
            'Authorization': Auth()
          }
        };
        
        fetch(`${process.env.REACT_APP_RALCO_API_URL}/api/party/upload-content`, requestOptions)
          .then(response => response.text())
          .then((result) => {

            const ref_id = uuid();
            let data = JSON.stringify({
              "reference_id": `${ref_id}`,
              "document_type": "PAN",
              "kycCategory": `${kycCategory}`,
              "consent": "Y",
              "consent_purpose": "for bank account purpose only",
              "kyc_validate": 1,
              "document_url":  `${JSON.parse(result)[0].contentUrl}`,
              "document_back_url":  `${JSON.parse(result)[0].contentUrl}`,
              "partyId": `${JSON.parse(result)[0].partyId}`,
              "partyContentId": `${JSON.parse(result)[0].id}`
            });
            
            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: `${process.env.REACT_APP_RALCO_API_URL}/api/decentro/ocr`,
              headers: { 
                'Content-Type': 'application/json',
                'Authorization': Auth()
              },
              data : data
            };
            
            axios.request(config)
            .then((response) => {
              console.log(JSON.stringify(response.data));
              response?.data?.panValidationStatus?.statusId === "VERIFIED" ? 
              toast({
                title: `PAN VERIFICATION COMPLETED - Status : ${response?.data?.panValidationStatus?.statusId}`,
                status: 'success',
                duration: 4000,
                isClosable: true,
                position: 'top'
              }) 
              :
              toast({
                title: `PAN Already Verified for this profession`,
                status: 'warning',
                duration: 5000,
                isClosable: true,
                position: 'top'
              })
              onClose4()
              setOcrSpinner(false)
              setOcrBtn(false)
            })
            .catch((error) => {
              console.log(error);
              setOcrSpinner(false)
              setOcrBtn(false)
              onClose4()
              toast({
                title: 'Oops we are facing some temporary issue with your request',
                status: 'error',
                duration: 4000,
                isClosable: true,
                position: 'top'
              })
            });
          }             
             )
          .catch(error => {
            console.log('error', error)
            onClose4()
            setOcrSpinner(false)
            setOcrBtn(false)
            toast({
              title: 'Oops we are facing some temporary issue with your request',
              status: 'error',
              duration: 4000,
              isClosable: true,
              position: 'top'
            })
          });
      };


  // handler verify face ------------------------
  // const verifyFace = () => {
  //   // Header

  //   // const myHeaders = new Headers();
  //   // myHeaders.append("client_id", "ralcosynergy_staging");
  //   // myHeaders.append("client_secret", "493YXjr4HscHfXM1GfwAw276hChG6lzo");
  //   // myHeaders.append("module_secret", "NK40kCOtccWjjzlgNXWSwC6RrYOjmU4w");
  //   // myHeaders.append("Content-Type", "multipart/form-data");
  //   // Form data
  //   const formdata = new FormData();
  //   formdata.append("reference_id", "eefa-abs1-0001-8915");
  //   formdata.append("consent", "Y");
  //   formdata.append("consent_purpose", "for bank account purpose only");
  //   formdata.append("threshold", "70");
  //   formdata.append("image1", files[0]);
  //   formdata.append("image2", files[1]);

  //   // request
  //   const requestOptions = {
  //     method: "POST",
  //     // mode: 'no-cors',
  //     // headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   if (sessionStorage.getItem("valid") === "true") {
      
  //     // Face API request parameters 
  //     if(files.length >= 2){
  //     fetch("http://localhost:8080/api/face_match", requestOptions)
  //       .then((response) => response.text())
  //       .then((result) => {
  //           setFaceRes(JSON.parse(result))
  //           setFaceSpinner(false);
  //           setFaceResult(true)
  //           setFaceBtn(true)
  //           sessionStorage.removeItem("valid");
  //       })
  //       .catch((error) => {
  //           console.log(error)
  //           setOcrSpinner(false);
  //         });
  //   }
  //   } else {
  //       if(errorFace.current?.style){
  //           errorFace.current.style.display = "block";
  //       }
  //   }
  //   if((files.length !== 2)){
  //       if(imgErrFace.current?.style){
  //           if(sessionStorage.getItem("valid") === 'true'){
  //               imgErrFace.current.style.display = 'block'
  //           }
  //       }
  //   }else{
  //       if(faceSpinner === false && ocrResult === true){
  //           setFaceSpinner(true);
  //           imgErrFace.current.style.display = 'none'
  //       }
  //   }

  // };

  // if (sessionStorage.getItem("valid") === "true"){
  //   if(errorFace.current?.style){
  //       errorFace.current.style.display = "none";
  //   }
    
  // }




  return (
    <>
      {/* OCR */}
      <Box borderWidth='1px' borderRadius='lg' p={3} bgColor={'white'} m={4}>
      {/* <Heading textAlign={'center'} size={'lg'} color={'#3e4444'}>Manual Verification</Heading> */}
      <form>
        <Input isDisabled={ocrBtn} type={"file"} multiple onChange={ocrImg} border={'unset'} p={1} pl={0} w={'90%'} display={'block'} m={'auto'} mt={1} />
        {/* <Text ref={imgErr} color={'red.500'} display={'none'} w={'90%'} m={'auto'} fontSize={'12px'}>Please Select Front and Back Image of Pan Card.</Text> */}
        {files2.length > 0 && <Text  color={'green.500'}  w={'90%'} m={'auto'} fontSize={'12px'}>PAN Photo Selected</Text>}
        <Box width={'90%'} m={'auto'}>
        <Button onClick={verifyOcr} w={'100%'} colorScheme={'twitter'} m={'auto'}  mt={3} 
        isLoading={ocrSpinner} isDisabled={ocrBtn}
        >
        verify
        </Button>
        {ocrSpinner && <Text color={'red.500'} mt={1} fontSize={'18px'} fontWeight={'semibold'}>Please Wait, we are processing your request...</Text>}
        </Box>
        <br />

        {/* {ocrResult && 
        
        <Card w={'90%'} m={'auto'}>
            {ocrRes.kycStatus === "SUCCESS" ? 
            <>
            <CardBody>
            <Text color={'green.600'}>Status : {ocrRes?.message}</Text>
            <Text color={'green.600'}>Id Status : {ocrRes?.kycResult?.idStatus}</Text>
            <Text color={'green.600'}>Card No : {ocrRes?.ocrResult?.cardNo}</Text>
            <Text color={'green.600'}>Name : {ocrRes?.ocrResult?.name}</Text>
            <Text color={'green.600'}>Father Name : {ocrRes?.ocrResult?.fatherName}</Text>
            <Text color={'green.600'}>DOB : {ocrRes?.ocrResult?.dateInfo}</Text>
            </CardBody>
            </>
            :
            <>
            <CardBody>
            <Text color={'red.500'}>Status : {ocrRes?.kycStatus}</Text>
            <Text color={'red.500'}>{ocrRes?.message.split('.')[1]}</Text>
            </CardBody>
            </>   
        }
        </Card>
        } */}
      </form>
      </Box>
      
      {/* Face Match
      <Box borderWidth='1px' borderRadius='lg' p={3} mt={5} bgColor={'white'} m={4}>
      <Heading textAlign={'center'} size={'lg'} color={'#3e4444'}>Face Match</Heading>
      <form>
        <Input isDisabled={faceBtn} type={"file"} multiple onChange={faceImg} border={'unset'} p={1} pl={0} w={'90%'} display={'block'} m={'auto'} mt={1} />
        <Text ref={errorFace}  color={'red.500'}  w={'90%'} m={'auto'} fontSize={'12px'} display={'none'}>Please First Verify Pan!</Text>
        <Text ref={imgErrFace} display={'none'} color={'red.500'}  w={'90%'} m={'auto'} fontSize={'12px'}>Please Select Image of Front PAN Card and Image of PAN Card Holder.</Text>
        <Box width={'90%'} m={'auto'}>
        <Button onClick={verifyFace} colorScheme={'twitter'} w={'100%'}  mt={3}
        isLoading={faceSpinner} isDisabled={faceBtn}
        >
        verify
        </Button>
        </Box>
        <br /> 
        {faceResult && 
         <Card w={'90%'} m={'auto'}>
            <CardBody>
            {faceRes?.data?.status === "SUCCESS" ? 
            <>
            <Text color={'green.600'}>Status : {faceRes?.data?.status}</Text>
            <Text color={'green.600'}>Match : {faceRes?.data?.match}</Text>
            </>
            :
            <>
            <Text color={'red.500'}>Status : {faceRes?.data?.status}</Text>
            <Text color={'red.500'}>Match : {faceRes?.data?.match}</Text>
            </>
        }
            </CardBody>
        </Card>}
      </form>
      </Box> */}
    </>
  );
}

export default PanVerification;
